export const AW_MARKET_VIEWS_API_URL = process.env?.AWAPI_MARKET_VIEWS_URL || '/api/wealth/analytics/market-views';
